import { Dialog, Button, Stack, Typography } from '@mui/material'
import * as Icons from '@mui/icons-material'

export const CropBulkCancelModal = ({ open, queueCount, onConfirm, onBack, onSubmitQueue }) => (
  <Dialog open={open} onClose={onBack}>
    <Stack sx={{ p: 3, minWidth: 340, gap: 2 }}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Icons.WarningAmberTwoTone color="warning" />
        <Typography variant="h5">Cancel Add Bulk Crops</Typography>
      </Stack>

      <Typography variant="body1">
        You have{' '}
        <strong>{queueCount} crop{queueCount !== 1 ? 's' : ''}</strong>{' '}
        queued but not yet submitted. Cancelling now will discard{' '}
        {queueCount !== 1 ? 'all of them' : 'it'} — none will be saved.
      </Typography>

      <Stack direction="row" justifyContent="flex-end" gap={1} sx={{ mt: 1 }}>
        <Button variant="outlined" onClick={onBack}>
          Go Back
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Discard & Close
        </Button>
        <Button variant="contained" color="primary" onClick={onSubmitQueue}>
          Submit {queueCount} Bulk Crop{queueCount !== 1 ? 's' : ''} & Close
        </Button>
      </Stack>
    </Stack>
  </Dialog>
)
